webpackJsonp([212839066777427],{

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    posts.map(function (_ref2) {
	      var post = _ref2.node;
	      var frontmatter = post.frontmatter;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: frontmatter.path },
	            frontmatter.title
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          frontmatter.date
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          frontmatter.excerpt
	        )
	      );
	    })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-d68469ef6cb48cc9be80.js